<!-- =========================================================================================
  File Name: UserView.vue
  Description: User View page
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->

<template>
	<div id="page-user-view">
		<table>
			<caption></caption>
			<thead>
				<tr>
					<th scope="col"></th>
				</tr>
			</thead>
			<tr>
				<td class="font-semibold">{{ $t("UploadFiles.File") + " " + "No:" }}</td>
				<td>{{ data.body.optimization_id }}</td>
			</tr>
			<tr>
				<td class="font-semibold">{{ $t("RoutingType.RoutingType") }}</td>
				<td>{{ data.body.routing_api }}</td>
			</tr>
		</table>
		<div class="vx-row">
			<div class="vx-col w-full md:w-1/2 pr-1 pt-1">
				<vx-card card-border>
					<div
						:class="{
							'flex justify-between flex-row-reverse items-center': iconRight,
							'text-center': !iconRight,
						}"
						:title="$t('Routing.RouteResult.TotalResources')"
					>
						<span class="" :class="[`text-${color}`, {'mb-4': !iconRight}]">
							<i class="material-icons">group</i>
						</span>
						<div class="truncate">
							<span class="font-semibold text-sm">{{ $t("Routing.RouteResult.TotalResources") }}</span>
							<h4 class="mb-1 font-bold">{{ data.body.total_vehicles }}</h4>
						</div>
					</div>
				</vx-card>
			</div>
			<div class="vx-col w-full md:w-1/2 pl-0 pt-1">
				<vx-card card-border>
					<div
						:class="{
							'flex justify-between flex-row-reverse items-center': iconRight,
							'text-center': !iconRight,
						}"
						:title="$t('Routing.RouteResult.TotalVisitPoints')"
					>
						<span class="inline-flex rounded-full" :class="[`text-${color}`, {'mb-4': !iconRight}]">
							<i class="material-icons">location_on</i>
						</span>
						<div class="truncate">
							<span class="font-semibold text-sm">{{ $t("Routing.RouteResult.TotalVisitPoints") }}</span>
							<h4 class="mb-1 font-bold">{{ data.body.total_visit_points }}</h4>
						</div>
					</div>
				</vx-card>
			</div>
		</div>
		<div class="vx-row">
			<div class="vx-col w-full md:w-1/2 pr-1 pt-1">
				<vx-card card-border>
					<div
						:class="{
							'flex justify-between flex-row-reverse items-center': iconRight,
							'text-center': !iconRight,
						}"
						:title="$t('Routing.RouteResult.ResourcesRouted')"
					>
						<span class="" :class="[`text-${color}`, {'mb-4': !iconRight}]">
							<i class="material-icons">how_to_reg</i>
						</span>
						<div class="truncate">
							<span class="font-semibold text-sm">{{ $t("RoutingNotification") }}</span>
							<h4 class="mb-1 font-bold">{{ data.body.total_routed_vehicles }}</h4>
						</div>
					</div>
				</vx-card>
			</div>
			<div class="vx-col w-full md:w-1/2 pl-0 pt-1">
				<vx-card card-border>
					<div
						:class="{
							'flex justify-between flex-row-reverse items-center': iconRight,
							'text-center': !iconRight,
						}"
						:title="$t('Routing.RouteResult.VisitPointsRouted')"
					>
						<span class="" :class="[`text-${color}`, {'mb-4': !iconRight}]">
							<i class="material-icons">where_to_vote</i>
						</span>
						<div class="truncate">
							<span class="font-semibold text-sm">{{ $t("RoutingNotification") }}</span>
							<h4 class="mb-1 font-bold">{{ data.body.total_routed_visit_points }}</h4>
						</div>
					</div>
				</vx-card>
			</div>
		</div>
		<div class="vx-row">
			<div class="vx-col w-full md:w-1/2 pr-1 pt-1">
				<vx-card card-border>
					<div
						:class="{
							'flex justify-between flex-row-reverse items-center': iconRight,
							'text-center': !iconRight,
						}"
						:title="$t('Routing.RouteResult.ResourcesNotRouted')"
					>
						<span class="" :class="[`text-${color}`, {'mb-4': !iconRight}]">
							<i class="material-icons">person_add_disabled</i>
						</span>
						<div class="truncate">
							<span class="font-semibold text-sm">{{ $t("RoutingNotNotification") }}</span>
							<h4 class="mb-1 font-bold">{{ data.body.total_not_routed_vehicles }}</h4>
						</div>
					</div>
				</vx-card>
			</div>
			<div class="vx-col w-full md:w-1/2 pl-0 pt-1">
				<vx-card card-border>
					<div
						:class="{
							'flex justify-between flex-row-reverse items-center': iconRight,
							'text-center': !iconRight,
						}"
						:title="$t('Routing.RouteResult.VisitPointsNotRouted')"
					>
						<span class="" :class="[`text-${color}`, {'mb-4': !iconRight}]">
							<i class="material-icons">location_off</i>
						</span>
						<div class="truncate">
							<span class="font-semibold text-sm">{{ $t("RoutingNotNotification") }}</span>
							<h4 class="mb-1 font-bold">{{ data.body.total_not_routed_visit_points }}</h4>
						</div>
					</div>
				</vx-card>
			</div>
		</div>
	</div>
</template>

<script>
export default {
	name: "NotificationViewOptimization",
	props: {
		data: {
			type: Object,
		},
		iconRight: {
			type: Boolean,
			default: false,
		},
		color: {
			type: String,
			default: "primary",
		},
		colorTo: {
			type: String,
		},
		type: {
			type: String,
			default: "line",
		},
	},
	filters: {
		removeDecimals(num = 0.03) {
			return num.toFixed(1);
		},
	},
};
</script>

<style lang="scss">
#avatar-col {
	width: 10rem;
}

#page-user-view {
	table {
		td {
			vertical-align: top;
			min-width: 140px;
			padding-bottom: 0.8rem;
			word-break: break-all;
		}

		&:not(.permissions-table) {
			td {
				@media screen and (max-width: 370px) {
					display: block;
				}
			}
		}
	}
}

@media screen and (min-width: 1201px) and (max-width: 1211px),
	only screen and (min-width: 636px) and (max-width: 991px) {
	#account-info-col-1 {
		width: calc(100% - 12rem) !important;
	}
}
</style>
